const BUCKETS = [
    {max: 24, fill: '#DC2626', track: '#FEE2E2'},
    {max: 49, fill: '#EA580C', track: '#FFEDD5'},
    {max: 74, fill: '#CA8A04', track: '#FEF9C3'},
    {max: 100, fill: '#16A34A', track: '#DCFCE7'},
];

function bucketIndex(pct) {
    const n = Math.round(Math.min(100, Math.max(0, Number(pct) || 0)));
    if (n <= 24) {
        return 0;
    }
    if (n <= 49) {
        return 1;
    }
    if (n <= 74) {
        return 2;
    }
    return 3;
}

/** Four-band coverage colors: red → orange → yellow → green. */
export function coverageScoreColor(pct) {
    return BUCKETS[bucketIndex(pct)].fill;
}

export function coverageTrackColor(pct) {
    return BUCKETS[bucketIndex(pct)].track;
}
